import {
  IconCheck,
  IconAlertCircle,
  IconArrowsShuffle,
} from "@tabler/icons-react";
import styles from "../TalentProfile.module.css";
import Button from "../../../../components/UI/Button/button";

export function mapToAiInsightsData(talentDetails = {}) {
  const roleFit = talentDetails?.aiRoleFit ?? talentDetails?.psychometricTestResult?.roleFit ?? [];
  const weaknesses = talentDetails?.aiInsights?.weaknesses ?? talentDetails?.psychometricTestResult?.weaknesses ?? [];
  const strengths = talentDetails?.aiInsights?.strengths ?? talentDetails?.psychometricTestResult?.strengths ?? [];
  const isRemote = !!talentDetails?.workMode?.includes?.("Work Remotely");
  const jobType = (talentDetails?.jobType || "")?.toLowerCase();

  const items = [];

  if (strengths?.length) {
    items.push({
      type: "check",
      text: (
        <>
          Top strength: <b>{String(strengths[0])}</b>.
        </>
      ),
    });
  }

  if (roleFit?.length) {
    const top3 = roleFit?.slice(0, 3);
    items.push({
      type: "check",
      text: (
        <>
          Also a match for{" "}
          {top3?.map((role, idx) => (
            <span key={role}>
              <b>{role}</b>
              {idx < top3?.length - 1 ? ", " : ""}
            </span>
          ))}{" "}
          — roles this talent can also do, mapped by our AI from their
          psychometrics.
        </>
      ),
    });
  }

  items.push({
    type: "check",
    text: (
      <>
        Strong fit for <b>{isRemote ? "remote-first" : "cross-functional"}</b>{" "}
        {jobType} teams.
      </>
    ),
  });

  if (weaknesses?.length) {
    items.push({
      type: "warn",
      text: (
        <>
          Growth area: <b>{String(weaknesses[0])?.toLowerCase()}</b>.
        </>
      ),
    });
  }

  return items;
}

const AiInsightsCard = ({
  onMatchClick,
  disabled,
  shortlisted,
  onMatchWithTalent,
  items = [],
}) => {
  return (
    <div className={`${styles.card} ${styles.aiinCard}`}>
      <div className={`${styles.cardBody} ${styles.aiinBody}`}>
        <div className={styles.aiinTitle}>AI INSIGHTS</div>
        <div className={styles.aiinList}>
          {items.map((item, i) => (
            <div className={styles.aiinItem} key={i}>
              <div
                className={`${styles.aiinIcon} ${
                  item?.type === "warn"
                    ? styles.aiinIconWarn
                    : styles.aiinIconCheck
                }`}
              >
                {item?.type === "warn" ? (
                  <IconAlertCircle size={13} />
                ) : (
                  <IconCheck size={13} />
                )}
              </div>
              <p className={styles.aiinText}>{item.text}</p>
            </div>
          ))}
        </div>
        {shortlisted ? (
          <Button
            className={styles.matchBtn}
            onClick={onMatchWithTalent}
            leftIcon={<IconArrowsShuffle size={17} />}
            loading={disabled}
            disabled={disabled}
          >
            Match with talent
          </Button>
        ) : (
          <Button
            className={styles.matchBtn}
            onClick={onMatchClick}
            loading={disabled}
            disabled={disabled}
            leftIcon={<IconArrowsShuffle size={17} />}
          >
            Match to a Job
          </Button>
        )}
      </div>
    </div>
  );
};

export default AiInsightsCard;
